export default "__VITE_ASSET__Di6_1Gos__"